<script lang="ts">
  import { Link } from "svelte-routing";
  import { mode, toggleMode } from "./theme";

  export let active = "";

  // StudentPlattform login. Baked at build via VITE_STUDENT_URL, prod default
  // matches the student app's host (same pattern as DemoPage.svelte).
  const STUDENT_URL =
    (import.meta.env.VITE_STUDENT_URL as string | undefined) ??
    "https://student.wiederdabei.de";

  // [path, label, navKey]
  const NAV: [string, string, string][] = [
    ["/avatar", "Avatar", "avatar"],
    ["/projekt", "Projekt", "project"],
    ["/jetzt-starten", "Jetzt starten", "hosted"],
    ["/self-hosted", "Self-Hosted", "self-hosted"],
    ["/schule-behoerden", "Schule & Behörden", "school-authorities"],
    ["/demo", "Demo", "demo"],
  ];

  let open = false;
  const close = () => (open = false);
  const toggle = () => (open = !open);
</script>

<header class="site-head">
  <div class="wrap site-head__in">
    <Link to="/" class="brand" on:click={close}>
      <img
        class="mark"
        src="/icon-wiederdabei.svg"
        alt=""
        width="34"
        height="34"
        style="width:34px;height:34px"
      />
      <span class="wm">wiederdabei</span>
    </Link>

    <nav class="nav" class:nav--open={open} aria-label="Hauptnavigation">
      {#each NAV as [path, label, key]}
        <Link to={path} class={key === active ? "is-active" : ""} on:click={close}>
          {label}
        </Link>
      {/each}
      <a
        class="nav-mobile-cta"
        href={STUDENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        on:click={close}>Login →</a
      >
      <button
        class="theme-toggle theme-toggle--mobile"
        type="button"
        aria-label={$mode === "dark"
          ? "Zum hellen Modus wechseln"
          : "Zum dunklen Modus wechseln"}
        aria-pressed={$mode === "dark"}
        title={$mode === "dark" ? "Heller Modus" : "Dunkler Modus"}
        data-testid="theme-toggle-mobile"
        on:click={toggleMode}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
        >
          {#if $mode === "dark"}
            <circle cx="12" cy="12" r="4.2"></circle>
            <path
              d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6"
            ></path>
          {:else}
            <path d="M20.5 14.6A8.6 8.6 0 1 1 9.4 3.5a6.9 6.9 0 0 0 11.1 11.1Z"
            ></path>
          {/if}
        </svg>
      </button>
      <!-- Language selector disabled for now (EN not yet available)
      <div class="lang-switch lang-mobile">
        <a class="on" href="#de" aria-current="page"
          ><span class="fl fl-de"><i></i><i></i><i></i></span>DE</a
        >
        <a class="is-soon" href="#en" title="English folgt in Kürze"
          ><span class="fl fl-gb"></span>EN</a
        >
      </div>
      -->
    </nav>

    <div class="nav-cta">
      <button
        class="theme-toggle"
        type="button"
        aria-label={$mode === "dark"
          ? "Zum hellen Modus wechseln"
          : "Zum dunklen Modus wechseln"}
        aria-pressed={$mode === "dark"}
        title={$mode === "dark" ? "Heller Modus" : "Dunkler Modus"}
        data-testid="theme-toggle"
        on:click={toggleMode}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
        >
          {#if $mode === "dark"}
            <circle cx="12" cy="12" r="4.2"></circle>
            <path
              d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6"
            ></path>
          {:else}
            <path d="M20.5 14.6A8.6 8.6 0 1 1 9.4 3.5a6.9 6.9 0 0 0 11.1 11.1Z"
            ></path>
          {/if}
        </svg>
      </button>
      <!-- Language selector disabled for now (EN not yet available)
      <div class="lang-switch">
        <a class="on" href="#de" aria-current="page"
          ><span class="fl fl-de"><i></i><i></i><i></i></span>DE</a
        >
        <a class="is-soon" href="#en" title="English folgt in Kürze"
          ><span class="fl fl-gb"></span>EN</a
        >
      </div>
      -->
      <Link to="/demo" class="btn btn--ghost">Demo</Link>
      <a
        class="btn btn--primary"
        href={STUDENT_URL}
        target="_blank"
        rel="noopener noreferrer">Login</a
      >
    </div>

    <button
      class="burger"
      aria-label="Menü"
      aria-expanded={open}
      on:click={toggle}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
      >
        <path d="M3 6h18M3 12h18M3 18h18"></path>
      </svg>
    </button>
  </div>
</header>
